import {Dispatch, FC, SetStateAction} from 'react'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import {getInvoiceArticle9DraftError} from '../core/invoiceArticle9'
import {InvoiceDateDeadlineHint} from './InvoiceDateDeadlineHint'

type Props = {
  invoiceType: number
  issueDateTime?: string
  now?: string
  isArticle9: boolean
  setIsArticle9: Dispatch<SetStateAction<boolean>>
  registrationDateTime: string
  setRegistrationDateTime: Dispatch<SetStateAction<string>>
}

type ToggleProps = Pick<Props, 'invoiceType' | 'isArticle9' | 'setIsArticle9'>

type IssueDateAccessoryProps = ToggleProps & {
  issueDateTime?: string | null
}

const InvoiceArticle9Toggle: FC<ToggleProps> = ({invoiceType, isArticle9, setIsArticle9}) => {
  const isTypeThree = invoiceType === 3

  return (
    <span className='form-check form-check-custom form-check-primary form-check-solid form-check-sm d-inline-flex align-items-center mb-0 me-3'>
      <input
        className='form-check-input'
        type='checkbox'
        checked={isArticle9}
        disabled={isTypeThree}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => setIsArticle9(event.target.checked)}
        aria-label='صورتحساب موضوع ماده ۹'
      />
      <span className={`form-check-label ms-2 ${isArticle9 ? 'text-warning fw-bolder' : ''}`}>
        ماده ۹
      </span>
    </span>
  )
}

const InvoiceArticle9IssueDateAccessory: FC<IssueDateAccessoryProps> = ({
  invoiceType,
  issueDateTime,
  isArticle9,
  setIsArticle9,
}) => (
  <>
    {!isArticle9 && <InvoiceDateDeadlineHint date={issueDateTime} />}
    <span className='float-end' data-testid='article9-issue-date-end'>
      <InvoiceArticle9Toggle
        invoiceType={invoiceType}
        isArticle9={isArticle9}
        setIsArticle9={setIsArticle9}
      />
    </span>
  </>
)

const InvoiceArticle9RegistrationField: FC<Props> = ({
  invoiceType,
  issueDateTime,
  now,
  isArticle9,
  registrationDateTime,
  setRegistrationDateTime,
}) => {
  const isTypeThree = invoiceType === 3
  const error = getInvoiceArticle9DraftError(
    isArticle9,
    invoiceType,
    registrationDateTime,
    issueDateTime,
    now
  )

  if (isTypeThree) {
    return (
      <div className='text-gray-600 fs-7'>ماده ۹ برای صورتحساب نوع سوم قابل انتخاب نیست.</div>
    )
  }

  if (!isArticle9) return null

  return (
    <CustomInputs
      type='datepicker'
      label='تاریخ و زمان ثبت صورتحساب'
      labelAccessory={<InvoiceDateDeadlineHint date={registrationDateTime} />}
      helpKey='header.indati2m'
      timePicker
      isRequired
      limitFromDate={issueDateTime}
      limitToDate={now}
      stateValue={{value: registrationDateTime, setValue: setRegistrationDateTime}}
      error={error}
      hint='این تاریخ مستقل از تاریخ صدور است و فقط برای صورتحساب موضوع ماده ۹ ثبت می‌شود.'
    />
  )
}

const InvoiceArticle9Fields: FC<Props> = ({
  invoiceType,
  issueDateTime,
  now,
  isArticle9,
  setIsArticle9,
  registrationDateTime,
  setRegistrationDateTime,
}) => {
  const isTypeThree = invoiceType === 3

  return (
    <section className='col-12 mt-5 rounded border bg-light p-4' aria-label='تنظیمات ماده ۹'>
      <InvoiceArticle9Toggle
        invoiceType={invoiceType}
        isArticle9={isArticle9}
        setIsArticle9={setIsArticle9}
      />
      {(isArticle9 || isTypeThree) && (
        <div className='mt-4'>
          <InvoiceArticle9RegistrationField
            invoiceType={invoiceType}
            issueDateTime={issueDateTime}
            now={now}
            isArticle9={isArticle9}
            setIsArticle9={setIsArticle9}
            registrationDateTime={registrationDateTime}
            setRegistrationDateTime={setRegistrationDateTime}
          />
        </div>
      )}
    </section>
  )
}

export {
  InvoiceArticle9Fields,
  InvoiceArticle9IssueDateAccessory,
  InvoiceArticle9RegistrationField,
  InvoiceArticle9Toggle,
}
